ClientDiversValidator.$inject = ['validator'];

export default function ClientDiversValidator(validator) {
    const instance = new validator();

    return instance;
}
